<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <!-- Loading from page -->
    <full-loading v-if="loading"/>

    <div class="page-wrapper-row full-height">
      <div class="page-wrapper-middle">
        <div class="page-container">
          <div class="page-content-wrapper">
            <!-- Page Head -->
            <div class="page-head">
              <div class="container padding-bottom-12">
                <!-- Title -->
                <div class="col-md-3 padding-null">
                  <div class="page-title offset-top-4">
                    <h1>Detalhes</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="page-content">
              <div class="container offset-top-20">
                <!-- Breadcrumb -->
                <ul class="page-breadcrumb breadcrumb breadcrumb-crud">
                  <li>
                    <a href="/dashboard">Dashboard</a>
                    <i class="fa fa-circle"></i>
                  </li>
                  <li>
                    <a>Pagamento</a>
                    <i class="fa fa-circle"></i>
                  </li>
                  <li>
                    <a href="/lista-pagamentos">Lista de Pagamentos</a>
                    <i class="fa fa-circle"></i>
                  </li>
                  <li>
                    <span class="breadcrumb-active">Detalhes</span>
                  </li>
                </ul>

                <div class="col-md-12 padding-null">
                  <div class="col-md-6 detail-content">
                    <div class="col-md-12">
                      <h1>Assinatura</h1>
                      <hr/>

                      <div>
                        <p>Status: <span>{{ dataSignature.subscriptionStatusStr }}</span></p>
                        <p>Pagamento: <span>{{ dataSignature.paymentMethodStr }}</span></p>
                        <p>Preço: <span>{{ dataSignature.price }}</span></p>
                        <p>Valor por Funcionário: <span>{{ dataSignature.pricePerEmployee }}</span></p>
                        <p>Valor Total: <span>R$ {{ dataSignature.totalCost }}</span></p>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="detail-form">
                        <h5><span>Gerar nova fatura:</span></h5>
                        <div class="input-group input-with-date">
                          <label>Data de vencimento</label>
                          <datepicker ref="programaticOpen3" v-model="expireAt" :language="ptBR"
                                      :format="customFormatter"/>
                          <i v-on:click="openCalendar()" class="fa fa-calendar" aria-hidden="true"></i>
                          <span v-if="dataError.date" class="error-msg">{{ dataError.date }}</span>
                        </div>

                        <div class="form-group">
                          <label for="value">Valor</label>
                          <input v-model.lazy="price" v-money="money" type="text" class="form-control" id="value"
                                 name="value"/>
                          <span v-if="dataError.price" class="error-msg">{{ dataError.price }}</span>
                        </div>

                        <div class="form-group">
                          <label for="description">Descrição</label>
                          <textarea v-model="dataCode.description" class="form-control" id="description"
                                    name="description"></textarea>
                        </div>

                        <button v-on:click="registerBillet()" :disabled="loadingSend"
                                v-bind:class="{'disable': loadingSend}" type="submit" class="btn default-btn-bue">
                          <span v-if="!loadingSend">Gerar</span>
                          <div class="loadingSend" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>

                        <div class="list-error">
                          <span v-if="invalidReason.length" v-for="iv in invalidReason"
                                class="error-msg">{{ iv }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 detail-content">
                    <div class="col-md-12">
                      <h1>Histórico de Pagamento</h1>
                      <hr/>

                      <div>
                        <p>Empresa: <span>{{ dataHistory.companyName }}</span></p>
                        <p>Funcionários: <span>{{ dataHistory.employees }}</span></p>
                        <p>Pagamento por: <span>{{ dataHistory.paymentMethodStr }}</span></p>
                        <p>Status: <span>{{ dataHistory.paymentStatusStr }}</span></p>
                        <p>Preço: <span>{{ dataHistory.price }}</span></p>
                        <p>Valor por Funcionário: <span>{{ dataHistory.pricePerEmployee }}</span></p>
                        <p>Valor Total: <span>{{ dataHistory.totalCost }}</span></p>
                        <p>Data de vencimento: <span>{{ dataHistory.expireAtStr }}</span></p>
                        <p>Data de pagamento: <span>{{ dataHistory.paidAtStr }}</span></p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  PAYMENT_HISTORIES_M_DUPLICATE,
  PAYMENT_HISTORY,
  SIGNATURE
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../../requestConfig";
import moment from "moment";
import {
  ALERT_SERVICE
} from "../../../../../msgAlertService";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import {
  VMoney
} from "v-money";
import datepicker from "vuejs-datepicker";

export default {
  name: "detail-payment",
  directives: {
    money: VMoney
  },
  components: {
    topMenu,
    fullLoading,
    datepicker
  },
  data() {
    return {
      ptBR: ptBR,
      loading: false,
      dataSignature: {},
      dataHistory: {},
      invalidReason: [],
      dataCode: {},
      dataError: {
        date: '',
        price: ''
      },
      price: 0,
      loadingSend: false,
      expireAt: '',
      money: {
        decimal: '.',
        thousands: ',',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    openCalendar: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    paymentHistory() {
      REQUEST_SERVICE.get(PAYMENT_HISTORY + this.$route.params.id).then((response) => {
        UTIL_SERVICE.console("RESULT PAYMENT_HISTORY:", response.data);
        this.dataHistory = response.data;
        this.loading = false;
      }).catch((reason) => {
        this.loading = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    signature() {
      this.loading = true;
      REQUEST_SERVICE.get(SIGNATURE + this.$route.params.subscriptionId).then((response) => {
        UTIL_SERVICE.console("RESULT SIGNATURE:", response.data);

        this.dataSignature = response.data;
        this.paymentHistory()
      }).catch((reason) => {
        this.loading = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    registerBillet() {
      if (!this.loadingSend) {
        this.dataError = {
          date: '',
          price: ''
        };
        this.invalidReason = [];
        if (this.expireAt && this.price && this.price !== 'R$ 0.00') {
          this.loadingSend = true;
          this.dataCode.id = this.$route.params.id;
          this.dataCode.price = this.price.replace("R$ ", "");
          this.dataCode.expireAt = moment(this.expireAt).format("YYYY-MM-DD");

          UTIL_SERVICE.console("DATA SEND:", this.dataCode);

          REQUEST_SERVICE.post(PAYMENT_HISTORIES_M_DUPLICATE, this.dataCode).then((response) => {
            UTIL_SERVICE.console("RESULT PAYMENT_HISTORIES_M_DUPLICATE:", response.data);

            ALERT_SERVICE.swal("Aviso", response.data, "success");
            this.loadingSend = false;
          }).catch((reason) => {
            reason.response.data.erros.map((value, index) => {
              ALERT_SERVICE.swal("Aviso", value.value, "warning");
            });

            this.loadingSend = false;
          });
        } else {
          if (!this.expireAt) {
            this.dataError.date = "Campo obrigatório.";
          }

          if (!this.price || this.price === 'R$ 0.00') {
            this.dataError.price = "Campo obrigatório.";
          }
        }
      }
    }
  },
  beforeMount() {
    this.signature();
  }
}
</script>

<style lang="scss">
.detail-content {
  border-radius: 4px;

  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

  .detail-form {
    width: 100%;

    h5 {
      margin: 0 0 20px;

      span {
        margin: 0;
        font-weight: bold;
        letter-spacing: 1px;
        text-transform: uppercase;
        border-bottom: 1px solid;
        padding: 0 4px;
      }
    }

    .form-group {
      margin-top: 15px;
    }
  }

  div {
    background: #fff;
    padding: 10px 30px;

    div {
      padding: 0;

      p {
        text-align: left;
        font-weight: bold;

        span {
          font-weight: normal;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/payment/detailPayment/detailPayment.vue